import { render, staticRenderFns } from "./OTPVerify.vue?vue&type=template&id=386241ec&scoped=true"
import script from "./OTPVerify.vue?vue&type=script&lang=js"
export * from "./OTPVerify.vue?vue&type=script&lang=js"
import style0 from "./OTPVerify.vue?vue&type=style&index=0&id=386241ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386241ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VBtn,VImg,VOtpInput})
